// Ochrana cest: dokud se neví, kdo je přihlášený, nic nebliká (tichý stav); nepřihlášeného pošle
// na /prihlaseni a zapamatuje si, kam chtěl (state.od → po přihlášení `navrat`); při chybě
// ověření ukáže důvod a „Zkusit znovu“.
import { Navigate, Outlet, useLocation } from 'react-router';
import { ChybaOvereni } from './ChybaOvereni';
import { usePrihlaseni } from './stav-prihlaseni';
import { TichyStav } from './TichyStav';

export function VyzadujePrihlaseni() {
  const { stav, chyba, overuji, zkusitZnovu } = usePrihlaseni();
  const umisteni = useLocation();

  switch (stav) {
    case 'nacitam':
      return <TichyStav />;
    case 'chyba':
      return <ChybaOvereni chyba={chyba} overuji={overuji} zkusitZnovu={zkusitZnovu} />;
    case 'neprihlasen':
      return (
        <Navigate
          to="/prihlaseni"
          replace
          state={{ od: `${umisteni.pathname}${umisteni.search}` }}
        />
      );
    default:
      return <Outlet />;
  }
}
